import type React from 'react';
import { type FieldValues, FormProvider, type UseFormProps, useForm } from 'react-hook-form';

export type HookFormProviderProps<T extends FieldValues = FieldValues, TContext = any> = {
  children?: React.ReactNode;
} & UseFormProps<T, TContext>;

export const HookFormProvider = <T extends FieldValues = FieldValues, TContext = any>(props: HookFormProviderProps<T, TContext>) => {
  const { children, ...rest } = props;
  const methods = useForm<T>(rest);
  return <FormProvider {...methods}>{children}</FormProvider>;
};
